var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigureVolumeCapsule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 250,
    height: 250,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard11"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.51269e-17,0.573665,-0.245851,1.5054e-17,66.6539,56.9568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.036,106.4L33.036,121.324L15.98,101.425L33.036,81.527L33.036,96.451L150.376,96.451L150.376,81.527L167.431,101.425L150.376,121.324L150.376,106.4L33.036,106.4Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.538578,-1.2326e-32,0,0.245851,46.6801,122.82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.147,106.4L34.147,121.324L15.98,101.425L34.147,81.527L34.147,96.451L167.431,96.451L167.431,81.527L167.431,121.324L167.431,106.4L34.147,106.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-49.3162,80.4517)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "h")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,20.1403,107.156)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "r")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,55.9373,59.234)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "V")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.88585,0,0,1.60533,-117.735,-89.0307)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135,
    cy: 147.5,
    rx: 45,
    ry: 22.5,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.28px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.64154,0,0,1.60533,-106.59,-131.556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.605,173.14C96.605,157.845 112.936,123.14 149.469,123.14C186.001,123.14 200,157.845 200,173.14",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.46px"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigureVolumeCapsule);
export default __webpack_public_path__ + "static/media/calc-figure-volume-capsule.7ae293849f19400a153f5604cfe6da19.svg";
export { ForwardRef as ReactComponent };